// front/src/api/passages.js
import { CONFIG } from '../config/config';

function authHeaders() {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
}

export async function validateRole(passageId, role) {
  const res = await fetch(`${CONFIG.API_URL}/passages/${passageId}/validate`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ role }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}

export async function patchPatient(passageId, patch) {
  const res = await fetch(`${CONFIG.API_URL}/passages/${passageId}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function byEtab(etabId) {
  const res = await fetch(`${CONFIG.API_URL}/passages/by-etab/${etabId}`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function lookupPassagePii(lookupParams) {
  const res = await fetch(`${CONFIG.API_URL}/passages/lookup-pii`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(lookupParams),
  });

  if (!res.ok) throw new Error(`HTTP ${res.status}`);

  return res.json();
}
